export const DEFAULT_FUEL_DISCOUNT = 6;
export const DEFAULT_EV_DISCOUNT = 10;
